// content

export default function WebbLoaderSmall() {

  return (
    <>
      <div className="spinner-border text-color-tint" role="status" style={{borderWidth:'0.06rem'}}>
        <span className="visually-hidden">loader...</span>
      </div>

    </>
    )
  }